export default "__VITE_ASSET__eT1STgnf__"